const getters = {
    currentAction: state => state.currentAction,
}

export default getters